import {
  Box,
  Flex,
  VStack,
  StackProps,
  BoxProps,
  FlexProps,
} from "@chakra-ui/react";
import styled from "@emotion/styled";
import React from "react";
import background from "../../images/background.svg";
import { SCREEN_SIZE } from "../../theme/foundations/breakpoints";

export const PageContainerPy = { base: 2, "2xs": 3, xs: 4, sm: 5, md: 5 };

export const PageContainerPx = {
  base: 2,
  "2xs": 3,
  xs: 4,
  sm: 5,
  md: 6,
  lg: 8,
};

export function PageContainer({ children, ...props }: FlexProps) {
  return (
    <Flex
      direction="column"
      px={PageContainerPx}
      py={PageContainerPy}
      maxW={SCREEN_SIZE.XXL}
      {...props}
    >
      {children}
    </Flex>
  );
}

export function PageHeadingContainer(props: StackProps): React.ReactElement {
  return (
    <Flex
      w="full"
      wrap="wrap"
      justify="space-between"
      mb={8}
      align="flex-start"
      gap={4}
      {...props}
    />
  );
}

export function SignInParentContainer(props: FlexProps): React.ReactElement {
  return <Flex w="full" minH="100vh" flexDirection="row" {...props} />;
}

export function SignInLHSContainer({
  children,
}: FlexProps): React.ReactElement {
  return (
    <Flex
      flex={1}
      justify="center"
      align="center"
      backgroundColor="gray.25"
      backgroundImage={`url(${background})`}
      backgroundSize="cover"
      px={3}
      py={2}
      display={{ base: "none", lg: "flex" }} // hide on small devices
    >
      {children}
    </Flex>
  );
}

export function SignInRHSContainer(props: FlexProps) {
  return (
    <Flex
      flex={1}
      backgroundColor="gray.25"
      justify="center"
      align="center"
      py={4}
      px={3}
      overflowY="auto"
      {...props}
    />
  );
}

export function SectionCard(props: BoxProps) {
  return (
    <Box
      borderWidth="1px"
      borderColor="gray.300"
      borderRadius="lg"
      backgroundColor="white"
      width="full"
      overflowX="hidden"
      shadow="sm"
      {...props}
    />
  );
}

export const ContentHeadingContainer = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 20px;
`;

export const FormContainer = styled(Flex)`
  width: 100%;
  flex-direction: column;
  max-width: 500px;
  padding: 30px;
  margin: auto;
`;

export const SignInFormContainer = styled(FormContainer)`
  max-width: 451px;
  padding: 30px;
  margin: auto;
`;

export const StdVStack = (props: StackProps) => (
  <VStack alignItems="flex-start" w="100%" {...props} />
);
